<template lang="pug">
    .flex
        .w-5.h-5.border.flex.items-center.justify-center(
            @click="onCheck"
            :class="{ 'bg-green-100': isChecked, 'cursor-pointer': !disabled, 'opacity-40 cursor-not-allowed': disabled }"
        )
            template(v-if="isChecked")
                img.block.w-3.h-3(:src="ICONS.checkmark")
        template(v-if="$slots.default")
            slot
</template>

<script>
//Configs
import { ICONS } from '../../../configs/icons';

export default {
    name: "checkbox",
    props: {
        checked: {
            type: Boolean,
            deafult: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isChecked: false,
        }
    },
    computed: {
        ICONS() {
            return ICONS
        },
    },
    methods: {
        onCheck() {
            if (this.disabled) {
                return
            }
            this.isChecked = !this.isChecked
            this.$emit('value', this.isChecked)
        },
    },
    watch: {
        checked: {
            handler(val) {
                this.isChecked = val
            },
            immediate: true,
        }
    }
}
</script>